import request from "@/utils/request";

export default function agentGetAllMonthlyVIP(params) {
    return request({
        url: `/device/memberMonthly/agentGetAllMonthlyVIP`,
        params: params
    })
}
